import { AU_LOCALE_CODE, NZ_LOCALE_CODE, US_LOCALE_CODE, getLanguageSubtagFromLocaleCode, getRegionOrLanguageFilterKeyFromLocaleCode, getTrimmedLocaleCode, } from "@notemeal/locale-utils";
import { isValidPassioProductLocalizationCode } from "./passioProductLocalizationLocales";
const DEFAULT_PRODUCT_LOCALIZATION = US_LOCALE_CODE;
/** Org locales that route product search by org region when no user override is set. */
const ORG_REGIONAL_PRODUCT_LOCALES = new Set([AU_LOCALE_CODE, NZ_LOCALE_CODE]);
export const buildRegionalSearchConfig = (regionFilterKey) => ({
    regionFilters: { [regionFilterKey]: 1 },
    typeFilters: ["branded", "generic"],
    strictRegionMode: false,
});
export { getRegionOrLanguageFilterKeyFromLocaleCode as regionFilterKeyFromProductLocalization } from "@notemeal/locale-utils";
const getSearchConfigForProductLocalization = (productLocalization) => {
    const regionFilterKey = getRegionOrLanguageFilterKeyFromLocaleCode(productLocalization);
    if (!regionFilterKey) {
        return null;
    }
    return buildRegionalSearchConfig(regionFilterKey);
};
const productRoutingFromLocaleCode = (productLocalization) => ({
    productLocalization,
    searchConfig: getSearchConfigForProductLocalization(productLocalization),
});
/**
 * Resolves Passio localization headers from app + org locale.
 *
 * @see https://passio.gitbook.io/nutrition-ai/rest-api/api-overview/localization
 */
export const getPassioLocalizationConfig = (appLocale, orgLocale = DEFAULT_PRODUCT_LOCALIZATION, options = {}) => {
    const localizationIso = getLanguageSubtagFromLocaleCode(appLocale);
    const fallbackProductLocalization = getTrimmedLocaleCode(appLocale) || DEFAULT_PRODUCT_LOCALIZATION;
    if (!options.regionLocalizationEnabled) {
        return {
            localizationIso,
            productLocalization: fallbackProductLocalization,
            searchConfig: null,
        };
    }
    const override = getTrimmedLocaleCode(options.productLocaleOverride ?? "");
    if (override && isValidPassioProductLocalizationCode(override)) {
        return {
            localizationIso,
            ...productRoutingFromLocaleCode(override),
        };
    }
    const trimmedOrgLocale = getTrimmedLocaleCode(orgLocale);
    if (ORG_REGIONAL_PRODUCT_LOCALES.has(trimmedOrgLocale)) {
        return {
            localizationIso,
            ...productRoutingFromLocaleCode(trimmedOrgLocale),
        };
    }
    return {
        localizationIso,
        ...productRoutingFromLocaleCode(fallbackProductLocalization),
    };
};
export const getDefaultFoodSearchLocale = (appLocale, orgLocale = DEFAULT_PRODUCT_LOCALIZATION) => getPassioLocalizationConfig(appLocale, orgLocale, { regionLocalizationEnabled: true }).productLocalization;
/** JSON string for Passio-Search-Config header, or undefined when no config. */
export const getPassioSearchConfigHeader = (searchConfig) => searchConfig ? JSON.stringify(searchConfig) : undefined;
/** Request headers for Passio REST search/detail calls. */
export const buildPassioRequestHeaders = (auth, localization) => {
    const headers = {
        Authorization: `Bearer ${auth.accessToken}`,
        "Passio-ID": auth.customerId,
        "Passio-Product-Localization": localization.productLocalization,
        "Localization-ISO": localization.localizationIso,
    };
    const searchConfigHeader = getPassioSearchConfigHeader(localization.searchConfig);
    if (searchConfigHeader) {
        headers["Passio-Search-Config"] = searchConfigHeader;
    }
    return headers;
};
//# sourceMappingURL=passioLocaleFromApp.js.map